import React, { useEffect, useState } from "react";
import './CardsPanel.scss'
import CardDashboard from "../../../../../components/moleculesv2/DashboardCard/CardDashboard";
import Text from "../../../../../components/Atomsv2/Text/Text";
import Card from "../../../../../components/Atomsv2/Card/Card";
import Skeleton from "../../../../../components/Atomsv2/Skeleton/Skeleton";


const CardsPanel = ({ data, loading }) => {
   
    const [cards, setCards] = useState(
        {
            operadoresAnalizados: null,
            riesgoAlto: null,
            porcentajeRiesgoAlto: null,
            riesgoMedio: null,
            porcentajeRiesgoMedio: null,
            riesgoBajo: null,
            porcentajeRiesgoBajo: null,
            descanzoNocturnoPromedio: null,
            sinRegistroReciente: null,
            porcentajeSinRegistroReciente: null
        }
    )

    useEffect(() => {
        if (data || data?.length > 0) {

            setCards({
                operadoresAnalizados: data?.length,
                riesgoAlto: data?.reduce((acc, item) => acc + (item.ID_NIVEL_FATIGA === 1 ? 1 : 0), 0),
                porcentajeRiesgoAlto: data?.reduce((acc, item) => acc + (item.ID_NIVEL_FATIGA === 1 ? 1 : 0), 0) / data?.length * 100,
                riesgoMedio: data?.reduce((acc, item) => acc + (item.ID_NIVEL_FATIGA === 2 ? 1 : 0), 0),
                porcentajeRiesgoMedio: data?.reduce((acc, item) => acc + (item.ID_NIVEL_FATIGA === 2 ? 1 : 0), 0) / data?.length * 100,
                riesgoBajo: data?.reduce((acc, item) => acc + (item.ID_NIVEL_FATIGA === 3 ? 1 : 0), 0),
                porcentajeRiesgoBajo: data?.reduce((acc, item) => acc + (item.ID_NIVEL_FATIGA === 3 ? 1 : 0), 0) / data?.length * 100,
                descanzoNocturnoPromedio: data?.reduce((acc, item) => acc + item.DESC_PROM_NOCTURNO, 0) / data?.length,
                sinRegistroReciente: data?.reduce((acc, item) => acc + (item.FECHA_ULTIMO_DESCANSO === null ? 1 : 0), 0),
                porcentajeSinRegistroReciente: data?.reduce((acc, item) => acc + (item.FECHA_ULTIMO_DESCANSO === null ? 1 : 0), 0) / data?.length * 100
            })


        }
    }, [data])
    const footerRiesgo = (id_riesgo, porciento, descripcion) => {
        const colores = {
            1: "var(--red-600)",
            2: "var(--yellow-600)",
            3: "var(--green-600)"
        }
        return (
            <label>
                <Text weight={"800"} size={"small"} color={colores[id_riesgo]}>
                    {porciento?.toFixed(2)}%
                </Text>
                <Text size={"small"}>
                    {descripcion}
                </Text>
            </label>
        )
    }
    return (
        <div className="CardsPanelMF">

            {
                loading ? (
                    <Card className="CardsPanelMF__card" style={{ width: '100%' }}>
                        <Skeleton width='250px' height='151px'></Skeleton>
                        <Skeleton width='250px' height='151px'></Skeleton>
                        <Skeleton width='250px' height='151px'></Skeleton>
                        <Skeleton width='250px' height='151px'></Skeleton>
                        <Skeleton width='250px' height='151px'></Skeleton>
                        <Skeleton width='250px' height='151px'></Skeleton>

                    </Card>
                ) :
                    <Card className="CardsPanelMF__card" style={{ width: '100%' }}>
                        <CardDashboard
                            style={{ width: '250px' }}
                            title="OPERADORES ANALIZADOS"
                            footer={(<div style={{ marginBottom: "20px" }}>Total en el reporte</div>)}
                            icon="group"
                            iconColor="var(--blue-600)"
                        >
                            <Text weight={"800"} size={"medium-large"}>
                                {cards?.operadoresAnalizados}
                            </Text>

                        </CardDashboard>
                        <CardDashboard
                            style={{ width: '250px' }}
                            title="RIESGO ALTO"
                            footer={footerRiesgo(1, cards?.porcentajeRiesgoAlto, "del total · fatiga extrema")}
                            icon="warning"
                            iconColor="var(--red-600)"
                        >
                            <Text weight={"800"} size={"medium-large"}>
                                {cards?.riesgoAlto}
                            </Text>

                        </CardDashboard>
                        <CardDashboard
                            style={{ width: '250px' }}
                            title="RIESGO MEDIO"
                            footer={footerRiesgo(2, cards?.porcentajeRiesgoMedio, "del total · alerta preventiva")}
                            icon="warning"
                            iconColor="var(--yellow-600)"
                        >
                            <Text weight={"800"} size={"medium-large"}>
                                {cards?.riesgoMedio}
                            </Text>

                        </CardDashboard>
                        <CardDashboard
                            style={{ width: '250px' }}
                            title="RIESGO BAJO"
                            footer={footerRiesgo(3, cards?.porcentajeRiesgoBajo, "del total · óptimo")}
                            icon="warning"
                            iconColor="var(--green-600)"
                        >
                            <Text weight={"800"} size={"medium-large"}>
                                {cards?.riesgoBajo}
                            </Text>

                        </CardDashboard>
                        <CardDashboard
                            style={{ width: '250px' }}
                            title="DESCANSO NOCTURNO PROMEDIO"
                            footer={(<div>Promedio general de la flota</div>)}
                            icon="bed"
                            iconColor="var(--blue-600)"
                        >
                            <Text weight={"800"} size={"medium-large"}>
                                {cards?.descanzoNocturnoPromedio?.toFixed(2)} hrs
                            </Text>

                        </CardDashboard>
                        <CardDashboard
                            style={{ width: '250px' }}
                            title="SIN REGISTRO RECIENTE"
                            footer={footerRiesgo(2, cards?.porcentajeSinRegistroReciente, "sin fecha de último descanso")}
                            icon="info"
                            iconColor="var(--yellow-600)"
                        >
                            <Text weight={"800"} size={"medium-large"}>
                                {cards?.sinRegistroReciente}
                            </Text>

                        </CardDashboard>
                    </Card>
            }

        </div>
    )
}
export default CardsPanel